import { render, staticRenderFns } from "./Trivia.vue?vue&type=template&id=6be0387d&scoped=true"
import script from "./Trivia.vue?vue&type=script&lang=ts"
export * from "./Trivia.vue?vue&type=script&lang=ts"
import style0 from "./Trivia.vue?vue&type=style&index=0&id=6be0387d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0387d",
  null
  
)

export default component.exports